var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report_in_gen button is-outlined is-info"},[_c('IconLoader',{staticClass:"icon_loader"}),_vm._v("\n    Rapports en cours de génération\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }